import { render, staticRenderFns } from "./BaseInputTextarea.vue?vue&type=template&id=0dff6009&"
import script from "./BaseInputTextarea.vue?vue&type=script&lang=js&"
export * from "./BaseInputTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports